import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';

export const CarrierLogo = (name: string) => {
  const { market } = useContext(AppContext);

  const imgWrapper = (imgName: string) => (
    <img alt={imgName} src={`${market.cdn}/g/rfe/carriers/${imgName}.svg`} />
  );

  switch (name.toLocaleLowerCase()) {
    case 'airmee':
      return imgWrapper('airmee');

    case 'best':
      return imgWrapper('best');

    case 'bring':
      return imgWrapper('bring');

    case 'budbee':
      return imgWrapper('budbee');

    case 'city mail':
      return imgWrapper('city_mail');

    case 'db schenker':
      return imgWrapper('db_schenker');

    case 'dhl':
      return imgWrapper('dhl');

    case 'dooris':
      return imgWrapper('dooris');

    case 'early bird':
      return imgWrapper('early_bird');

    case 'fedex':
      return imgWrapper('fedex');

    case 'instabox':
      return imgWrapper('instabox');

    case 'jetpak':
      return imgWrapper('jetpak');

    case 'postnord':
      return imgWrapper('postnord');

    case 'ups':
      return imgWrapper('ups');

    default:
      return imgWrapper('unknown');
  }
};
